<template>
  <div 
    id="polluted_wastewater_ship"
    class="polluted_wastewater"
  >
    <div 
      v-if="receivedData"
      class="polluted_wastewater-item"
    >
      <TabsCustomGraphic
          :received-data="receivedData"
          :id="'polluted_wastewater_ship-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
          :stacked="false"
      />
    </div> 
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'PollutedWastewater',
  
  components: {
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'polluted_wastewater',
      cloneElementId: 'polluted_wastewater_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '96,97').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .water_loss-item {
    margin-top: 20px;
  }
</style>